import { useLocation } from 'react-router-dom';

type AuthFrom = { authFrom: string };

export const useAuthFrom = () => {
  const { state } = useLocation();
  const { authFrom } = (state as AuthFrom) || { authFrom: '/' };

  return authFrom;
};
